/**
 * Created by Darius on 2017.04.02.
 */
import authService from "./services/auth-services";
import dashboardService from "./services/dashboard-services";
'use strict';

const promiseMiddleware = store => next => action => {
    if (isPromise(action.payload)) {
        store.dispatch({type: 'ASYNC_START', subtype: action.type});

        const currentView = store.getState().viewChangeCounter;
        const skipTracking = action.skipTracking;

        action.payload.then(
            response => {
                const currentState = store.getState();
                if (!skipTracking && currentState.viewChangeCounter !== currentView) {
                    return;
                }
                console.log('RESULT', response);
                if (response.json && response.status !== 200) {
                    throw response;
                }
                if (response.json) {
                    action.payload = response.json();
                } else {
                    action.payload = response;
                    store.dispatch({type: 'ASYNC_END', promise: action.payload});
                }
                store.dispatch(action);
            }
        ).catch(error => {
            const currentState = store.getState();
            if (!skipTracking && currentState.viewChangeCounter !== currentView) {
                return;
            }

            //here i can log all errors to server

            console.error(error);
            action.error = true;

            if (error.json) {
                error.json().then(body => {
                    action.payload = body;
                    if (!action.skipTracking) {
                        store.dispatch({type: 'ASYNC_END', promise: action.payload});
                    }

                    if (error.status == 401) {
                        store.dispatch({type: 'LOGOUT', payload: authService.Auth.logout()});
                        store.dispatch({type: 'CLOSE_WEB_SOCKET', payload: dashboardService.DashboardServices.closeWebSocket()});
                    } else {
                        store.dispatch({type: 'ON_ERROR', payload: action.payload, hasError: true});
                    }
                });
            }
            else {
                action.payload = error;
                store.dispatch({type: 'ON_ERROR', payload: action.payload, hasError: true});
            }
        });

        return;
    }

    next(action);
};

const localStorageMiddleware = store => next => action => {
    if (action.type === 'LOGIN') {
        if (!action.error && action.payload) {
            window.localStorage.setItem('token', Math.random().toString(36).substring(7));
        }
    } else if (action.type === 'LOGOUT') {
        window.localStorage.setItem('token', '');
    }

    next(action);
};

function isPromise(v) {
    return v && typeof v.then === 'function';
}


export {promiseMiddleware, localStorageMiddleware}